import React, { useState, useEffect, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Alert,
  CircularProgress,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Tabs,
  Tab,
  Chip,
  Tooltip,
  IconButton,
  Dialog,
  DialogContent,
  DialogActions,
  AppBar,
  Toolbar,
  Slide
} from '@mui/material';
import { 
  Edit as EditIcon, 
  Lock as LockIcon,
  Home as HomeIcon,
  ArrowBack as ArrowBackIcon,
  Description as DescriptionIcon,
  Visibility as VisibilityIcon,
  Download as DownloadIcon,
  Close as CloseIcon
} from '@mui/icons-material';
import { ContextSession } from "../../services/ContextSession";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const EditarRecursosHumanos = () => {
  const { tramiteId } = useParams();
  const navigate = useNavigate();
  let sessi = useContext(ContextSession);
  let demandaId = sessi.getVariable("demandaID"); 
  const [error, setError] = useState(null);
  const [demanda, setDemanda] = useState(null);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [adjuntos, setAdjuntos] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [currentFile, setCurrentFile] = useState(null);
  const [loadingPreview, setLoadingPreview] = useState(false);
  
  // Estado del formulario para los campos editables
  const [formData, setFormData] = useState({
    montodemandado: '',
    montoprovision: '',
    cuentaprovision: '',
    fechamaximacontestacion: ''
  });

  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState({ type: '', text: '' });

  const API_UPDATE_TRAMITE = `https://bei360.injupemp.gob.hn:8444/api/tramite/actualizar-rrhh/${demandaId}/`;

  // Manejar cambio de pestaña
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // Cargar datos del trámite específico
  useEffect(() => {
    const fetchDemanda = async () => {
      try {
        setLoading(true);
        const token = sessi.sessionData.token;

        // Obtener demanda por ID 
        const response = await fetch(`https://bei360.injupemp.gob.hn:8444/api/tramite/${demandaId}/`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error(`Error HTTP: ${response.status}`);
        }

        const demandaData = await response.json();

        if (!demandaData) {
          throw new Error("La demanda no existe o la estructura de datos es incorrecta");
        }

        console.log('Datos de demanda recibidos:', demandaData);

        // Procesar datos de la demanda según la nueva estructura
        const demandaProcesada = {
          ...demandaData,
          tramiteid: demandaData.id || demandaId,
          numerodemanda: demandaData.numerodemanda || 'No disponible', 
          numeroexpediente: demandaData.numeroexpediente || 'No disponible',
          fechapresentacion: demandaData.fechapresentacion,
          naturaleza: demandaData.naturaleza,
          nombredemandado: demandaData.nombredemandado,
          nombredemandante: demandaData.nombredemandante,
          tipodemandante: demandaData.tipodemandante,
          tipodemanda: demandaData.tipodemanda,
          motivodemanda: demandaData.motivodemanda || 'No disponible',
          estado: demandaData.estado || 'No definido',
          procuradorNombre: demandaData.procuradorasignado || 'No asignado',
          juzgado: demandaData.juzgado || 'No especificada',
          moneda: demandaData.moneda,
          tipocambio: demandaData.tipocambio,
          montoestimacion: demandaData.montoestimacion,
          cuentaestimacion: demandaData.cuentaestimacion,
          cuentaprovision: demandaData.cuentaprovision,
          cuentagastos: demandaData.cuentagastos,
          riesgocredito: demandaData.riesgocredito,
          observaciones: demandaData.observaciones,
          accioninstitucion: demandaData.accioninstitucion,
          resultadoprimerainstancia: demandaData.resultadoprimerainstancia,
          resultadosegundainstancia: demandaData.resultadosegundainstancia,
          fechaactuacion: demandaData.fechaactuacion,
          fechamaximacontestacion: demandaData.fechamaximacontestacion || null,
          montogastoslegales: demandaData.montogastoslegales,
          montodemandado: demandaData.montodemandado,
          montoprovision: demandaData.montoprovision,
          valordefinitivoconciliado: demandaData.valordefinitivoconciliado,
          cuentavalordefinitivo: demandaData.cuentavalordefinitivo,
          resultadocierre: demandaData.resultadocierre,
          descripcioncierre: demandaData.descripcioncierre,
        };

        setDemanda(demandaProcesada);

        // Inicializar formData con los campos editables
        setFormData({
          montodemandado: demandaData.montodemandado || '',
          montoprovision: demandaData.montoprovision || '',
          fechamaximacontestacion: demandaData.fechamaximacontestacion || ''
        });

      } catch (err) {
        console.error("Error al cargar la demanda:", err);
        setError(err.message || "Error desconocido al cargar la demanda");
      } finally {
        setLoading(false);
      }
    };

    fetchDemanda();
  }, [demandaId, sessi.sessionData.token]);

  // Cargar documentos adjuntos
  useEffect(() => {
    const fetchAdjuntos = async () => {
      try {
        const token = sessi.sessionData.token;
        const response = await fetch(`https://bei360.injupemp.gob.hn:8444/api/adjuntos/listar/?entity_id=${demandaId}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          }
        });

        if (response.ok) {
          const adjuntosData = await response.json();
          console.log('Datos de adjuntos recibidos:', adjuntosData);
          
          //  La API devuelve necesitamos extraer el array
          if (adjuntosData && adjuntosData.adjuntos) {
            setAdjuntos(adjuntosData.adjuntos);
          } else {
            setAdjuntos([]);
          }
        } else {
          console.error('Error al cargar adjuntos:', response.status);
          setAdjuntos([]);
        }
      } catch (error) {
        console.error('Error al cargar adjuntos:', error);
        setAdjuntos([]);
      }
    };

    if (demandaId) {
      fetchAdjuntos();
    }
  }, [demandaId, sessi.sessionData.token]);

  // Función para obtener archivo en base64
  const fetchAdjuntoBase64 = async (adjuntoId) => {
    try {
      const token = sessi.sessionData.token;
      const response = await fetch(`https://bei360.injupemp.gob.hn:8444/api/adjuntos/base64?id=${adjuntoId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json'
        }
      });
      
      if (!response.ok) {
        throw new Error(`Error HTTP: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (!data.base64 || !data.nombre || !data.tipo_archivo) {
        console.error('Estructura de respuesta inesperada:', data);
        throw new Error('La respuesta del servidor no tiene el formato esperado');
      }
      
      return {
        base64: data.base64,
        nombreArchivo: data.nombre,
        tipoArchivo: data.tipo_archivo,
        id: data.id
      };
    } catch (error) {
      console.error('Error obteniendo archivo en base64:', error);
      throw new Error(`No se pudo obtener el archivo: ${error.message}`);
    }
  };

  // Función para manejar vista previa
  const handlePreview = async (adjuntoId, nombreArchivo) => {
    try {
      setLoadingPreview(true);
      const archivo = await fetchAdjuntoBase64(adjuntoId);
      setCurrentFile(archivo);
      setPreviewOpen(true);
    } catch (error) {
      console.error('Error al obtener vista previa:', error);
      setMessage({
        type: 'error',
        text: `Error al cargar la vista previa: ${error.message}`
      });
    } finally {
      setLoadingPreview(false);
    }
  };

  // Función para manejar descarga
  const handleDescargarAdjunto = async (adjuntoId, nombreArchivo) => {
    try {
      const archivo = await fetchAdjuntoBase64(adjuntoId);
      
      // Crear un enlace temporal para descargar el archivo
      const link = document.createElement('a');
      link.href = `data:${archivo.tipoArchivo};base64,${archivo.base64}`;
      link.download = archivo.nombreArchivo || nombreArchivo;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      setMessage({
        type: 'success',
        text: 'Archivo descargado correctamente'
      });
    } catch (error) {
      console.error('Error al descargar archivo:', error);
      setMessage({
        type: 'error',
        text: `Error al descargar el archivo: ${error.message}`
      });
    }
  };

  // Cerrar vista previa
  const handleClosePreview = () => {
    setPreviewOpen(false);
    setCurrentFile(null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Para campos monetarios (montodemandado y montoprovision)
    if (name === 'montodemandado' || name === 'montoprovision') {
      // Permitir solo números y un punto decimal
      let filteredValue = value.replace(/[^0-9.]/g, '');
      
      // Separar parte entera y decimal
      const parts = filteredValue.split('.');
      
      // Limitar parte entera a 14 dígitos
      if (parts[0] && parts[0].length > 14) {
        parts[0] = parts[0].substring(0, 14);
      }
      
      // Limitar parte decimal a 2 dígitos
      if (parts[1] && parts[1].length > 2) {
        parts[1] = parts[1].substring(0, 2);
      }
      
      // Reconstruir el valor
      filteredValue = parts[0];
      if (parts[1] !== undefined) {
        filteredValue += '.' + parts[1];
      }
      
      setFormData(prev => ({
        ...prev,
        [name]: filteredValue
      }));
      
      // Limpiar error específico cuando el usuario empieza a escribir
      if (errors[name]) {
        setErrors(prev => ({
          ...prev,
          [name]: ''
        }));
      }
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;
    
    // Validar monto demandado (obligatorio)
    if (!formData.montodemandado.trim()) {
      newErrors.montodemandado = 'El monto demandado es obligatorio';
      isValid = false;
    } else {
      const montoDemandado = parseFloat(formData.montodemandado);
      if (isNaN(montoDemandado)) {
        newErrors.montodemandado = 'El monto demandado debe ser un número válido';
        isValid = false;
      } else if (montoDemandado < 0) {
        newErrors.montodemandado = 'El monto demandado debe ser mayor o igual a 0';
        isValid = false;
      } else if (formData.montodemandado.includes('.') && formData.montodemandado.split('.')[1]?.length > 2) {
        newErrors.montodemandado = 'El monto demandado no puede tener más de 2 decimales';
        isValid = false;
      }
    }
    
    // Validación del monto de provisión según la naturaleza de la demanda
    if (demanda?.naturaleza === 2) { // Demanda EN CONTRA
      // Validar que el campo NO esté vacío
      if (!formData.montoprovision || formData.montoprovision.trim() === '') {
        newErrors.montoprovision = 'El monto de provisión es obligatorio para demandas en contra';
        isValid = false;
      } else {
        const montoProvision = parseFloat(formData.montoprovision);
        const montoDemandado = formData.montodemandado ? parseFloat(formData.montodemandado) : null;
        
        // Validar que sea un número
        if (isNaN(montoProvision)) {
          newErrors.montoprovision = 'El monto de provisión debe ser un número válido';
          isValid = false;
        }
        // Validar que sea mayor o igual a 0
        else if (montoProvision < 0) {
          newErrors.montoprovision = 'El monto de provisión debe ser mayor o igual a 0';
          isValid = false;
        }
        // Validar que no sea mayor que el monto demandado (si el monto demandado existe)
        else if (montoDemandado !== null && montoProvision > montoDemandado) {
          newErrors.montoprovision = `El monto de provisión (${montoProvision.toFixed(2)}) no puede ser mayor al monto demandado (${montoDemandado.toFixed(2)})`;
          isValid = false;
        }
        // Validar formato: máximo 14 dígitos enteros, 2 decimales
        else {
          const partes = formData.montoprovision.split('.');
          const parteEntera = partes[0];
          const parteDecimal = partes[1] || '';
          
          // Validar longitud de parte entera
          if (parteEntera.length > 14) {
            newErrors.montoprovision = 'La parte entera no puede tener más de 14 dígitos';
            isValid = false;
          }
          
          // Validar longitud de parte decimal
          if (parteDecimal.length > 2) {
            newErrors.montoprovision = 'La parte decimal no puede tener más de 2 dígitos';
            isValid = false;
          }
          
          // Validar valor máximo absoluto
          const maximoPermitido = 99999999999999.99;
          if (montoProvision > maximoPermitido) {
            newErrors.montoprovision = `El valor máximo permitido es ${maximoPermitido.toLocaleString('es-HN')}`;
            isValid = false;
          }
        }
      }
    } else { // Demanda A FAVOR (naturaleza 1 u otra)
      // Para demandas a favor, validar que sea 0
      if (formData.montoprovision && formData.montoprovision.trim() !== '' && 
          formData.montoprovision !== '0' && formData.montoprovision !== '0.00') {
        newErrors.montoprovision = 'Para demandas a favor, el monto de provisión debe ser 0.00';
        isValid = false;
      }
    }
    
    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setUpdating(true);
    setMessage({ type: '', text: '' });

    try {
      const payload = {
        montodemandado: formData.montodemandado ? parseFloat(formData.montodemandado) : null,
        fechamaximacontestacion: formData.fechamaximacontestacion || null
      };
      
      // Validación específica para demandas en contra antes de enviar
      if (demanda.naturaleza === 2) {
        if (!formData.montoprovision || formData.montoprovision.trim() === '') {
          setMessage({
            type: 'error',
            text: 'El monto de provisión es obligatorio para demandas en contra'
          });
          setUpdating(false);
          return;
        }
        payload.montoprovision = parseFloat(formData.montoprovision);
      } else {
        // Para demandas a favor, el monto de provisión siempre debe ser 0
        payload.montoprovision = 0;
      }

      console.log('Enviando datos:', payload);
      console.log('URL:', API_UPDATE_TRAMITE);

      const response = await fetch(API_UPDATE_TRAMITE, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sessi.sessionData.token}`
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(`Error ${response.status}: ${response.statusText} - ${JSON.stringify(errorData)}`);
      }

      const result = await response.json();
      console.log('Respuesta del servidor:', result);
      
      setMessage({
        type: 'success',
        text: 'Datos actualizados correctamente'
      });

      // Redirigir después de 2 segundos
      setTimeout(() => {
        navigate('/Legal/SecretariaLegal');
      }, 2000);

    } catch (error) {
      console.error('Error al actualizar los datos:', error);
      setMessage({
        type: 'error',
        text: `Error al actualizar los datos: ${error.message}`
      });
    } finally {
      setUpdating(false);
    }
  };

  const formatNumber = (value) => {
    if (value == null || value === '' || isNaN(parseFloat(value))) {
      return 'No asignado';
    }
    return parseFloat(value).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const getNaturalezaText = (naturaleza) => {
    switch (naturaleza) {
      case 1: return 'A Favor';
      case 2: return 'En Contra';
      default: return 'No definida';
    }
  };

  const getNaturalezaColor = (naturaleza) => {
    switch (naturaleza) {
      case 1: return 'success';
      case 2: return 'error';
      default: return 'default';
    }
  };

  // Determinar si el monto de provisión está bloqueado
  const isProvisionLocked = demanda?.naturaleza === 1;

  // Función para renderizar la vista previa según el tipo de archivo
  const renderPreview = () => {
    if (!currentFile) return null;

    const { base64, tipoArchivo, nombreArchivo } = currentFile;

    if (tipoArchivo.startsWith('image/')) {
      return (
        <img 
          src={`data:${tipoArchivo};base64,${base64}`} 
          alt={nombreArchivo}
          style={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }}
        />
      );
    } else if (tipoArchivo === 'application/pdf') {
      return (
        <embed 
          src={`data:${tipoArchivo};base64,${base64}`} 
          type="application/pdf"
          width="100%"
          height="600px"
        />
      );
    } else if (tipoArchivo.startsWith('text/')) {
      return (
        <Box sx={{ p: 2, backgroundColor: '#f5f5f5', borderRadius: 1 }}>
          <Typography variant="body2" component="pre" sx={{ whiteSpace: 'pre-wrap' }}>
            {atob(base64)}
          </Typography>
        </Box>
      );
    } else {
      return (
        <Box sx={{ textAlign: 'center', p: 4 }}>
          <DescriptionIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
          <Typography variant="h6" color="text.secondary">
            Vista previa no disponible
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Este tipo de archivo no se puede previsualizar en el navegador.
          </Typography>
          <Button 
            variant="contained" 
            onClick={() => handleDescargarAdjunto(currentFile.id, nombreArchivo)}
            sx={{ mt: 2 }}
          >
            <DownloadIcon sx={{ mr: 1 }} />
            Descargar Archivo
          </Button>
        </Box>
      );
    }
  };

  if (loading) {
    return (
      <Container maxWidth="lg" sx={{ mt: 4, textAlign: 'center' }}>
        <CircularProgress />
        <Typography sx={{ mt: 2 }}>Cargando trámite #{tramiteId}...</Typography>
      </Container>
    );
  }

  if (!demanda) {
    return (
      <Container maxWidth="lg" sx={{ mt: 4 }}>
        <Alert severity="error" sx={{ mb: 3 }}>
          Trámite #{demandaId} no encontrado
        </Alert>
        <Button 
          startIcon={<ArrowBackIcon />} 
          onClick={() => navigate('/Legal/RecursosHumanos')}
          variant="contained"
        >
          Volver a la lista
        </Button>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl" sx={{ mt: 2, mb: 4 }}>
        <Box display="flex" alignItems="center" justifyContent="center">
          <Box>
            <Typography variant="h5" fontWeight="bold" gutterBottom>
              Editar Montos de la demanda
            </Typography>
          </Box>
        </Box>
      
      {message.text && (
        <Alert 
          severity={message.type} 
          sx={{ mb: 3 }}
          onClose={() => setMessage({ type: '', text: '' })}
        >
          {message.text}
        </Alert>
      )}

      <form onSubmit={handleSubmit}>
        <Paper sx={{ maxWidth: 1250, margin: '0 auto', mb: 3 }}>
          {/* Tabs centrados */}
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs 
              value={tabValue} 
              onChange={handleTabChange} 
              centered
              sx={{
                '& .MuiTabs-flexContainer': {
                  justifyContent: 'center'
                },
                '& .MuiTabs-indicator': {
                  display: 'none'
                }
              }}
            >
              <Tab label="Información General" />
              <Tab label="Detalles Legales" />
              <Tab label="Información Financiera" />
              <Tab label="Resultados" />
              <Tab label="Documentos" />
            </Tabs>
          </Box>
          
          {/* Contenido de los tabs */}
          <TableContainer>
            <Table sx={{ minWidth: 1000 }}>
              <TableBody>
                {/* Pestaña 1: Información General */}
                {tabValue === 0 && (
                  <>
                    <TableRow>
                      <TableCell sx={{ width: '35%', fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>No. Demanda:</TableCell>
                      <TableCell sx={{ width: '65%' }}>{demanda?.numerodemanda || 'No disponible'}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ width: '35%', fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>No. Expediente:</TableCell>
                      <TableCell sx={{ width: '65%' }}>{demanda?.numeroexpediente || 'No disponible'}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ width: '35%', fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Fecha Presentación:</TableCell>
                      <TableCell sx={{ width: '65%' }}>{demanda?.fechapresentacion || 'No disponible'}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ width: '35%', fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Naturaleza:</TableCell>
                      <TableCell sx={{ width: '65%' }}>
                        {demanda?.naturaleza === 1 ? 'A Favor' : 
                         demanda?.naturaleza === 2 ? 'En Contra' : 'No definida'}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ width: '35%', fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Demandado:</TableCell>
                      <TableCell sx={{ width: '65%' }}>{demanda?.nombredemandado || 'No disponible'}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ width: '35%', fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Demandante:</TableCell>
                      <TableCell sx={{ width: '65%' }}>{demanda?.nombredemandante || 'No disponible'}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ width: '35%', fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Tipo de Demandante:</TableCell>
                      <TableCell sx={{ width: '65%' }}>
                        {demanda?.tipodemandante === 1 ? 'Persona Natural' : 
                         demanda?.tipodemandante === 2 ? 'Persona Jurídica' : 
                         demanda?.tipodemandante === 3 ? 'Proveedor' : 
                         demanda?.tipodemandante === 4 ? 'Colaborador' : 
                         demanda?.tipodemandante === 5 ? 'Otros' : 'No definida'}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ width: '35%', fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Estado:</TableCell>
                      <TableCell sx={{ width: '65%' }}>
                        <Chip 
                          label={demanda?.estado?.toUpperCase()} 
                          color={ 
                            demanda?.estado?.toLowerCase() === 'cerrado' ? 'warning' : 
                            demanda?.estado?.toLowerCase() === 'en proceso' ? 'primary' : 'success' 
                          } 
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ width: '35%', fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Observaciones:</TableCell>
                      <TableCell sx={{ width: '65%' }}>{demanda?.observaciones || 'No disponible'}</TableCell>
                    </TableRow>
                  </>
                )}
                
                {/* Pestaña 2: Detalles Legales */}
                {tabValue === 1 && (
                  <>
                    <TableRow>
                      <TableCell sx={{ width: '35%', fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Tipo de Demanda:</TableCell>
                      <TableCell sx={{ width: '65%' }}>
                        {demanda?.tipodemanda === 1 ? 'Daños y Perjuicios' : 
                         demanda?.tipodemanda === 2 ? 'Ejecución de Garantías' : 
                         demanda?.tipodemanda === 3 ? 'Ejecución de Pagos' : 
                         demanda?.tipodemanda === 4 ? 'Ejecución de Títulos' : 
                         demanda?.tipodemanda === 5 ? 'Ejecutiva' : 
                         demanda?.tipodemanda === 6 ? 'Extra Contractual' : 
                         demanda?.tipodemanda === 7 ? 'Laboral' : 
                         demanda?.tipodemanda === 8 ? 'Monitorio' : 
                         demanda?.tipodemanda === 9 ? 'Nulidad de Instrumentos' : 
                         demanda?.tipodemanda === 10 ? 'Responsabilidad Contractual' : 
                         demanda?.tipodemanda === 11 ? 'Otros' : 'No definida'}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ width: '35%', fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Motivo de demanda:</TableCell>
                      <TableCell sx={{ width: '65%' }}>{demanda?.motivodemanda || 'No disponible'}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ width: '35%', fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Procurador asignado:</TableCell>
                      <TableCell sx={{ width: '65%' }}>{demanda?.procuradorNombre || 'No asignado'}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ width: '35%', fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Juzgado:</TableCell>
                      <TableCell sx={{ width: '65%' }}>
                        {demanda?.juzgado === 1 ? 'Juzgado Civil' : 
                         demanda?.juzgado === 2 ? 'Juzgado Primero de Letras Departamental' : 
                         demanda?.juzgado === 3 ? 'Juzgado Primero de Letras Seccional' : 
                         demanda?.juzgado === 4 ? 'Ministerio Público' : 
                         demanda?.juzgado === 5 ? 'Otros' : 'No definida'}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ width: '35%', fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Fecha de Actuación:</TableCell>
                      <TableCell sx={{ width: '65%' }}>{demanda?.fechaactuacion || 'No disponible'}</TableCell>
                    </TableRow>
                   <TableRow>
                      <TableCell sx={{ width: '35%', fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Fecha de Maxima Contestación:</TableCell>
                      <TableCell sx={{ width: '65%' }}>{demanda?.fechamaximacontestacion || 'No disponible'}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ width: '35%', fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Acción de la Institución:</TableCell>
                      <TableCell sx={{ width: '65%' }}>
                        {demanda?.accioninstitucion || 'No disponible'}
                      </TableCell>
                    </TableRow>
                  </>
                )}
                
                {/* Pestaña 3: Información Financiera */}
                {tabValue === 2 && (
                  <>
                    <TableRow>
                      <TableCell sx={{ width: '35%', fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Tipo de Moneda:</TableCell>
                      <TableCell sx={{ width: '65%' }}>
                        {demanda?.moneda === 1 ? 'Lempiras (HNL)' : 
                         demanda?.moneda === 2 ? 'Dólares (USD)' : 
                         demanda?.moneda === 3 ? 'Euros (EUR)' : 'No definida'}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ width: '35%', fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Tipo de Cambio:</TableCell>
                      <TableCell sx={{ width: '65%' }}>{demanda?.tipocambio || 'No asignado'}</TableCell>
                    </TableRow>
                    
                    {/* Campo editable: Monto Demandado */}
                    <TableRow>
                      <TableCell sx={{ width: '35%', fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Monto Demandado *:</TableCell>
                      <TableCell sx={{ width: '65%' }}>
                        <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          name="montodemandado"
                          value={formData.montodemandado}
                          onChange={handleChange}
                          placeholder="0.00"
                          error={!!errors.montodemandado}
                          helperText={errors.montodemandado || "Campo obligatorio. Formato: 99999999999999.99 (14 enteros, 2 decimales)"}
                          disabled={updating}
                          required
                          inputProps={{
                            inputMode: 'decimal',
                            pattern: "^\\d{1,14}(\\.\\d{0,2})?$",
                            title: "Ingrese un número con máximo 14 dígitos enteros y 2 decimales"
                          }}
                        />
                        <Typography variant="caption" color="textSecondary" sx={{ mt: 1, display: 'block' }}>
                          Valor actual: {formatNumber(demanda.montodemandado)}
                        </Typography>
                      </TableCell>
                    </TableRow>
                    
                    {/* Campo editable: Monto Provisión */}
                    <TableRow>
                      <TableCell sx={{ width: '35%', fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Monto Provisión:</TableCell>
                      <TableCell sx={{ width: '65%' }}>
                        <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          name="montoprovision"
                          value={isProvisionLocked ? '0.00' : formData.montoprovision}
                          onChange={isProvisionLocked ? undefined : handleChange}
                          placeholder={isProvisionLocked ? "0.00" : "0.00"}
                          error={!!errors.montoprovision}
                          helperText={
                            errors.montoprovision || 
                            (isProvisionLocked
                              ? "Campo bloqueado para demandas a favor - Valor automático: 0.00" 
                              : demanda.naturaleza === 2
                                ? "Obligatorio para demandas en contra. Formato: 99999999999999.99 (14 enteros, 2 decimales) | Rango: 0.00 ≤ Monto ≤ Monto Demandado"
                                : "Formato: 99999999999999.99 (14 enteros, 2 decimales)")
                          }
                          InputProps={{
                            endAdornment: isProvisionLocked && <LockIcon color="disabled" />,
                            readOnly: isProvisionLocked
                          }}
                          disabled={updating || isProvisionLocked}
                          inputProps={{
                            inputMode: isProvisionLocked ? 'none' : 'decimal',
                            pattern: isProvisionLocked ? null : "^\\d{1,14}(\\.\\d{0,2})?$",
                            title: isProvisionLocked 
                              ? "Campo bloqueado" 
                              : "Ingrese un número con máximo 14 dígitos enteros y 2 decimales (Formato: 99999999999999.99)"
                          }}
                        />
                        <Typography variant="caption" color="textSecondary" sx={{ mt: 1, display: 'block' }}>
                          {isProvisionLocked
                            ? "Demanda a favor: Monto Provisión automáticamente en 0.00"
                            : demanda.naturaleza === 2
                              ? `Valor actual: ${formatNumber(demanda.montoprovision)} | Máximo permitido: ${formatNumber(formData.montodemandado)}`
                              : `Valor actual: ${formatNumber(demanda.montoprovision)}`
                          }
                        </Typography>
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell sx={{ width: '35%', fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Monto de estimación:</TableCell>
                      <TableCell sx={{ width: '65%' }}>
                        {demanda?.montoestimacion ? 
                         `L. ${parseFloat(demanda.montoestimacion).toLocaleString('es-HN')}` : 'No definido'}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ width: '35%', fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Monto gastos legales:</TableCell>
                      <TableCell sx={{ width: '65%' }}>
                        {demanda?.montogastoslegales || 'No disponible'}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ width: '35%', fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Cuenta Estimación:</TableCell>
                      <TableCell sx={{ width: '65%' }}>
                        {demanda?.cuentaestimacion || 'No disponible'}
                      </TableCell>
                    </TableRow>
                     <TableRow>
                      <TableCell sx={{ width: '35%', fontWeight: 'bold', backgroundColor: '#f5f5f5' }}> Cuenta Provisión:</TableCell>
                      <TableCell sx={{ width: '65%' }}>
                        <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          name="cuentaprovision"
                          value={formData.cuentaprovision}
                          onChange={handleChange}
                          error={!!errors.cuentaprovision}
                          helperText={errors.cuentaprovision || ""}
                          disabled={updating}
                          required
                        />
                        <Typography variant="caption" color="textSecondary" sx={{ mt: 1, display: 'block' }}>
                          Valor actual: {formatNumber(demanda.cuentaprovision)}
                        </Typography>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ width: '35%', fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Cuenta Gastos:</TableCell>
                      <TableCell sx={{ width: '65%' }}>
                        {demanda?.cuentagastos || 'No disponible'}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ width: '35%', fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Riesgo de credito:</TableCell>
                      <TableCell sx={{ width: '65%' }}>
                        {demanda?.riesgocredito === 1 ? 'Si' : 
                         demanda?.riesgocredito === 2 ? 'No' : 'No definida'}
                      </TableCell>
                    </TableRow>
                  </>
                )}
                
                {/* Pestaña 4: Resultados */}
                {tabValue === 3 && (
                  <>
                    <TableRow>
                      <TableCell sx={{ width: '35%', fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Resultado Primera Instancia:</TableCell>
                      <TableCell sx={{ width: '65%' }}>
                        {demanda?.resultadoprimerainstancia === 1 ? 'Favorable' : 
                         demanda?.resultadoprimerainstancia === 2 ? 'Desfavorable' : 
                         demanda?.resultadoprimerainstancia === 3 ? 'No aplica' : 'No definida'}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ width: '35%', fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Resultado Segunda Instancia:</TableCell>
                      <TableCell sx={{ width: '65%' }}>
                        {demanda?.resultadosegundainstancia === 1 ? 'Favorable' : 
                         demanda?.resultadosegundainstancia === 2 ? 'Desfavorable' : 
                         demanda?.resultadosegundainstancia === 3 ? 'No aplica' : 'No definida'}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ width: '35%', fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Valor Definitivo Conciliado:</TableCell>
                      <TableCell sx={{ width: '65%' }}>
                        {demanda?.valordefinitivoconciliado || 'No disponible'}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ width: '35%', fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Cuenta Valor Definitivo:</TableCell>
                      <TableCell sx={{ width: '65%' }}>
                        {demanda?.cuentavalordefinitivo || 'No disponible'}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ width: '35%', fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Resultado de la Demanda:</TableCell>
                      <TableCell sx={{ width: '65%' }}>
                        {demanda?.resultadocierre === 1 ? 'Favorable' : 
                         demanda?.resultadocierre === 2 ? 'Desfavorable' : 
                         demanda?.resultadocierre === 3 ? 'Conciliación' : 
                         demanda?.resultadocierre === 4 ? 'Proceso desistido o abandono de proceso' : 
                         demanda?.resultadocierre === 5 ? 'Otros' : 'No definida'}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ width: '35%', fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Descripción Cierre:</TableCell>
                      <TableCell sx={{ width: '65%' }}>
                        {demanda?.descripcioncierre || 'No disponible'}
                      </TableCell>
                    </TableRow>
                  </>
                )}
                
                {/* Pestaña 5: Documentos */}
                {tabValue === 4 && (
                  <TableRow>
                    <TableCell colSpan={2} sx={{ padding: 0 }}>
                      <Box sx={{ p: 3 }}>
                        <Typography variant="h6" sx={{ mb: 2, textAlign: 'center', fontWeight: 'bold' }}>
                          Documentos Adjuntos ({adjuntos.length})
                        </Typography>
                        {adjuntos.length > 0 ? (
                          <Box sx={{ 
                            display: 'flex', 
                            flexDirection: 'column', 
                            gap: 1, 
                            maxHeight: '400px', 
                            overflowY: 'auto' 
                          }}>
                            {adjuntos.map((adjunto) => (
                              <Paper 
                                key={adjunto.id} 
                                elevation={1} 
                                sx={{ 
                                  display: 'flex', 
                                  alignItems: 'center', 
                                  gap: 2, 
                                  p: 2, 
                                  '&:hover': { backgroundColor: '#f5f5f5' } 
                                }}
                              >
                                <DescriptionIcon fontSize="medium" color="primary" />
                                <Box sx={{ flexGrow: 1 }}>
                                  <Typography variant="body1" sx={{ fontWeight: '500' }}>
                                    {adjunto.nombre || 'Documento sin nombre'}
                                  </Typography>
                                  <Typography variant="caption" color="textSecondary" sx={{ fontStyle: 'italic' }}>
                                    {adjunto.usuario_id ? `Subido por : ${adjunto.usuario_nombre}` : 'Usuario no disponible'}
                                  </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', gap: 1 }}>
                                  <Tooltip title="Vista previa">
                                    <IconButton 
                                      size="medium" 
                                      onClick={() => handlePreview(adjunto.id, adjunto.nombre)}
                                      color="primary"
                                      disabled={loadingPreview}
                                    >
                                      {loadingPreview ? <CircularProgress size={24} /> : <VisibilityIcon />}
                                    </IconButton>
                                  </Tooltip>
                                  <Tooltip title="Descargar">
                                    <IconButton 
                                      size="medium" 
                                      onClick={() => handleDescargarAdjunto(adjunto.id, adjunto.nombre)}
                                      color="success"
                                    >
                                      <DownloadIcon />
                                    </IconButton>
                                  </Tooltip>
                                </Box>
                              </Paper>
                            ))}
                          </Box>
                        ) : (
                          <Typography 
                            variant="body1" 
                            color="textSecondary" 
                            sx={{ textAlign: 'center', py: 4 }}
                          >
                            No hay documentos adjuntos
                          </Typography>
                        )}
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        {/* Resumen de cambios y botones de acción */}
        <Box sx={{ mt: 3, mb: 3 }}>
          <Alert severity="info">
            <Typography variant="subtitle2" gutterBottom>
              Resumen de cambios:
            </Typography>
            <Typography variant="body2">
              <strong>Monto Demandado:</strong> {formatNumber(formData.montodemandado)}
            </Typography>
            <Typography variant="body2">
              <strong>Monto Provisión:</strong> {isProvisionLocked ? '0.00 (automático para demanda a favor)' : `${formatNumber(formData.montoprovision)}`}
            </Typography>
            <Typography variant="body2">
              <strong>Fecha Máxima Contestación:</strong> {formData.fechamaximacontestacion || 'Sin cambios'}
            </Typography>
          </Alert>
        </Box>

        {/* Botones de acción */}
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
          <Button
            color="error"
            onClick={() => navigate('/Legal/RecursosHumanos')}
            disabled={updating}
            size="medium"
          >
            Cancelar
          </Button>
          <Button
            type="submit"
            variant="contained"
            disabled={updating}
            startIcon={updating ? <CircularProgress size={20} /> : <EditIcon />}
            size="medium"
            sx={{ minWidth: 160 }}
          >
            {updating ? 'Actualizando...' : 'Actualizar Trámite'}
          </Button>
        </Box>
      </form>

      {/* Dialog para vista previa */}
      <Dialog
        open={previewOpen}
        onClose={handleClosePreview}
        TransitionComponent={Transition}
        maxWidth="lg"
        fullWidth
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {currentFile?.nombreArchivo || 'Vista previa'}
            </Typography>
            <IconButton
              edge="end"
              color="inherit"
              onClick={handleClosePreview}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent sx={{ p: 0, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          {renderPreview()}
        </DialogContent>
        <DialogActions>
           <Button 
          color="error"
          onClick={handleClosePreview}>
            Cerrar
          </Button>
          <Button 
            variant="contained"          
            onClick={() => handleDescargarAdjunto(currentFile?.id, currentFile?.nombreArchivo)}
            startIcon={<DownloadIcon />}
          >
            Descargar
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default EditarRecursosHumanos;